import parse from "html-react-parser";
import { cn } from "@/lib";
import { useMemo } from "react";

type Props = {
  htmlString: string;
  className?: string;
};

export default function HtmlRenderer({ htmlString = "", className }: Props) {
  const parsed = useMemo(() => {
    if (!htmlString) return null;

    return parse(htmlString, {
      trim: true, // Remove extra whitespace
    });
  }, [htmlString]);

  if (!htmlString) return null;

  return <div className={cn("max-w-none", className)}>{parsed}</div>;
}
